import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { HTTP_INTERCEPTORS } from '@angular/common/http';

import { CardModule } from 'primeng/card';

import {
    MsalModule,
    MsalInterceptor,
    MSAL_INSTANCE,
    MSAL_GUARD_CONFIG,
    MSAL_INTERCEPTOR_CONFIG,
    MsalGuard,
    MsalBroadcastService,
    MsalService
} from '@azure/msal-angular';

import { ButtonModule } from 'primeng/button';

import { SharedModule } from 'projects/shared/src/public_api';
import { SharedSettings } from 'projects/shared/src/lib/models/shared-settings';
import {
    MsalInstanceFactory, MsalInterceptorConfigFactory, MsalGuardConfigFactory
} from 'projects/shared/src/lib/authentication/msal-factories';
import { ApiInterceptor } from 'projects/shared/src/lib/services/api.interceptor';
import { AuthService } from 'projects/shared/src/lib/authentication/auth.service';
import { LoggingService } from 'projects/shared/src/lib/services/logging.service';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './pages/home/home.component';
import { UsefulLinksComponent } from './pages/useful-links/useful-links.component';
import { UnauthorizedComponent } from './pages/unauthorized/unauthorized.component';
import { NoSitesComponent } from './pages/no-sites/no-sites.component';

import { environment } from '@environment';
import { ReloadService } from '@shared/services/reload.service';
import { BrowserProviderService } from '@shared/services/browser-provider.service';


@NgModule({
    declarations: [
        AppComponent,
        HomeComponent,
        UsefulLinksComponent,
        UnauthorizedComponent,
        NoSitesComponent
    ],
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        ButtonModule,
        CardModule,
        MsalModule,
        SharedModule.forRoot(environment),
        AppRoutingModule
    ],
    providers: [{
            provide: HTTP_INTERCEPTORS,
            useClass: MsalInterceptor,
            multi: true
        }, {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true
        }, {
            provide: MSAL_INSTANCE,
            useFactory: MsalInstanceFactory,
            deps: [ LoggingService, SharedSettings, BrowserProviderService ]
        }, {
            provide: MSAL_GUARD_CONFIG,
            useFactory: MsalGuardConfigFactory,
            deps: [ SharedSettings ]
        }, {
            provide: MSAL_INTERCEPTOR_CONFIG,
            useFactory: MsalInterceptorConfigFactory,
            deps: [ SharedSettings ]
        },
        MsalGuard,
        MsalBroadcastService,
        MsalService
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
    constructor(authService: AuthService, reloadService: ReloadService) {
        // check login early in site startup
        authService.isAuthenticated().subscribe(_ => { });
        reloadService.Start();
    }
}
